import type { IconProps } from '../create-icon'

// Official VALORANT Duelist role glyph (traced from Riot's role displayIcon).
// Filled disc with the symbol punched out as negative space — matches in-game art.
export function ValDuelist({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <g transform="translate(0,128) scale(0.1,-0.1)">
        <path d="M500 1264 c-36 -7 -103 -32 -149 -55 l-84 -41 187 -187 186 -186 186 186 187 187 -84 41 c-138 68 -284 87 -429 55z M71 929 c-94 -191 -94 -387 0 -578 l41 -84 187 187 186 186 -186 186 -187 187 -41 -84z M979 824 l-184 -184 186 -186 187 -187 41 84 c89 181 93 381 12 556 -56 118 -33 126 -242 -83z M451 296 l-184 -184 84 -41 c191 -94 387 -94 578 0 l84 41 -184 184 c-101 101 -186 184 -189 184 -3 0 -88 -83 -189 -184z" />
      </g>
    </svg>
  )
}
